import { useRef, useState } from 'react';
import { EyeIcon, EyeOffIcon } from '../Icon';
import './style.css';
import { RxCross2 } from "react-icons/rx";
import { Button } from '../Button';
import { IoSendSharp } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import DatePicker from "react-datepicker";
import moment from "moment";


// ========================================= Radio/LabelYesNo Component============================================

export const LabelYesNo = (props) => {

    return (
    <div className={`label-yn ${props?.inline?'inline':''}`}>
        <label className="label-yn-label flex gap-2">{props.label}</label>

        {props.box && <span className="label-yn-box">{props.box}</span>}

        <div className="label-yn-btn">
        <div className={`ynbtn first ${(props.value==='YES')?'active':''}`}  onClick={()=>props.handleChange(props.name ,props.value==='YES'?'':'YES')}>Yes</div>
        <div className={`ynbtn ${(props.value==='NO')?'active':''}`} onClick={()=>props.handleChange(props.name,props.value==='NO'?'':'NO')}>No</div>
        </div>

    </div>
    );
};
  // ========================================= Radio / LabelYesNo Component============================================

// ===================================Error Message======================================================

    export const ErrorMessage = (props) =>{

        return <div className="error-container">
            <span>{props?.error}</span>
        </div>
    }

// ===================================Error Message======================================================


// ===================================FormGroup======================================================

export const FormGroup = (props) => {
    return <div className={`form-group column-${props?.col} ${props?.mediaQueries}`}>{props.children}</div>;
};

FormGroup.defaultProps = {
    col: 2,
    mediaQueries: "sm md lg"
};

// ===================================FormGroup======================================================
// ===================================FormField======================================================

export const FormField = (props) => {
    return <div className={`form-field ${props?.mediaQueries}`}>{props.children}</div>;
};

FormField.defaultProps = {
    col: 2,
    mediaQueries: "sm md lg"
};

// ===================================FormField======================================================
// ===================================Input======================================================

    export const Input =(props) =>{
        const [toggle, setToggle] = useState(false);
        
        const handleToggle = () =>{
            setToggle((prev) => !prev)
        }


        return<div className="input-div">
            {props?.label && <label className="input-label">{props?.label}</label>}
            <div className="input-inner-div">
                <input 
                    className="input"
                    name={props?.name}
                    value={props?.value || ''}
                    placeholder={props?.hint}
                    type={props?.password ? toggle ? 'text': 'password' :props?.type }
                    onChange={(e)=>props?.handleChange(props.name, e.target.value)}
                /> 
                {props?.password && <span className='icon icon-pass' onClick={handleToggle}>{ toggle ? <EyeOffIcon/> :<EyeIcon/>}</span>} 
            </div>
        </div>
            
    }
    
    Input.defaultProps = {
        type: 'text',
    }
// ===================================Input======================================================

// ===================================chat Input======================================================

export const ChatInput =(props) =>{
    const [toggle, setToggle] = useState(false);
    
    const handleToggle = () =>{
        setToggle((prev) => !prev)
    }

    const handleTemplets = (e, id, code) => {
        e.preventDefault()
        props?.handleTemplets(id, code)
        setToggle(false)
    }
    return<div className="chatinput-div">
        {props?.label && <label className="input-label">{props?.label}</label>}
        <div className="chatinput-inner-div">
            <Button 
                title={<FiPlus />}
                varient="icon"
                onClick={handleToggle}
            />
            <Textarea 
                name={props?.name}
                value={props?.value}
                rows={props?.rows}
                cols={props?.cols}
                placeholder={props?.hint}
                handleChange={props?.handleChange}
            />
            {/* <Button 
                title={<AiFillAudio />}
                varient="icon"
                onClick={props?.onClickAudio}
            />
            <Button 
                title={<MdMessage />}
                varient="icon"
                onClick={props?.onClickMessage}
            /> */}
            <Button 
                title={<IoSendSharp />}
                varient="icon"
                onClick={props?.onClickSend}
            />
        </div>
        <div className="short-window" 
            style={{
                display: toggle ? 'flex' : 'none',
            }}
        >
            <div className="">
                {props?.templates?.list?.map((itm, index) => {return <div className="tamplets-div" ><a href='' onClick={(e)=>handleTemplets(e,itm[props?.templates?.id], itm[props?.templates?.code])} key={index}>{itm[props?.templates?.title]}</a> <hr/></div>})}
            </div>

            
        </div>
    </div>
    
}

ChatInput.defaultProps = {
    type: 'text',
    rows: 2,
    cols: 1,
}
// ===================================chat Input======================================================


// ===================================textarea======================================================

export const Textarea =(props) =>{


    return<div className="textarea-div">
        {props?.label && <label className="textarea-label">{props?.label}</label>}
        <div className="textarea-inner-div">
            <textarea 
                className="textarea"
                name={props?.name}
                value={props?.value || ''}
                rows={props?.rows}
                cols={props?.cols}
                placeholder={props?.hint}
                onChange={(e)=>props?.handleChange(props.name, e.target.value)}
            ></textarea>
        </div>
    </div>
        
}

Textarea.defaultProps = {
    rows: 10,
    cols: 30,
}
// ===================================textarea======================================================

// ===================================Dropdown======================================================
    export const Dropdown = (props) =>{
        
        return<div className="dropdown-section">
            {props?.label && <label className="dropdown-label">{props?.label}</label>}
            <div className="dropdown-inner-div">
                <select className="dropdown" id={props.id}
                    onChange={(e) => props.handleChange(props.name, e?.target?.value, props?.options?.list.find(itm=>itm[props?.options?.value]===e?.target?.value))}
                    value={props?.selected}
                >
                    <option value="0">--Select--</option>

                    {props?.options?.list?.map((itm,index) => {
                        return <option id={index} key={index} value={itm[props?.options?.value]}>{itm[props?.options?.name]}</option>
                    })}
                </select>
            </div>
        </div>
    }
// ===================================Dropdown======================================================
// ===================================file======================================================

export const FileUpload = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const refImage = useRef();
    const handleFileChange = (event) => {
      props?.handleFileChange(props?.name, event.target.files[0])
      setSelectedFile(event.target.files[0]);
    };
  
    // console.log(selectedFile)
    const handleUpload = () => {
      refImage.current.click();
    };
  
    return (
      <div className="file-main-section">
        {props?.label && <label className="input-label">{props?.label}</label>}
        <div className="file-section">
          <p className="file-name-display">{props?.fileName}</p>
          <input
            ref={refImage}
            className="file"
            type="file"
            accept=".png, .jpg, .jpeg,.pdf"
            name={props?.name}
            onChange={handleFileChange}
          />
          <button onClick={handleUpload}>{selectedFile?.name ? selectedFile?.name : 'Upload file'}</button>
        </div>
      </div>
    );
  };
  
// ===================================file======================================================

// ===================================table======================================================
export const FormTableCell = (props)=> {
    return <div className="field-table-cell " style={{width: props?.width, minWidth: props?.minWidth}}>
        {props.children}
    </div>
}

export const FormTableRow = (props)=> {
    return <div className={`field-table-row ${props?.headers ? 'headers': ''}`} style={{width: props?.width, minWidth: props?.minWidth}}>
        {props.children}
    
    </div>
}

export const FormTable = (props)=> {
    return <div className="field-table " style={{width: props?.width, minWidth: props?.minWidth}}>
        {props.children}

        {/* {props?.handleAddRow && <div className="field-table-add-row" style={{
        display: props?.show ? 'none' : 'flex',
        }}>
        <Button 
            title={props.AddBtnTitle || 'Add More +'}
            varient="outlined"
            onClick={props.handleAddRow}
        />
        </div>
        
        } */}

        
    </div>
}

FormTable.defaultProps ={
    minWidth: ''
}

// export const FormTableRowDelete = (props)=> {
//     return <div className="field-table-del-row">
//     <Button varient="fieldDelBtn" onClick={props.handleDelete} />
//     </div>
// }
// ===================================table======================================================

// ===================================Popup======================================================

export const Popup = (props)=> {

    return props?.trigger && <div className="popup-section">
        <div className='popup-background'></div>

        <div className="popup-content" style={{maxWidth: props?.maxWidth}}>
            <div className="popup-header">
                <Button varient="icon" title={<RxCross2 />} onClick={props?.setTrigger}/>
            </div>
            <div className="popup-body">
                {props.children}
            </div>
        </div>
        
    </div>
}

// ===================================Popup======================================================
// ===================================container======================================================

export const Container = ({children, width})=> {

    return <div className="container-section">
        <div className="container-inner-div" style={{width: width}}>
            {children}
        </div>
    </div>
}

Container.defaultProps = {
    width: '100%'
}

export const Center = ({children}) =>{
    return<div className="center-div">
        {children}
    </div>
}
  // ===================================container======================================================
// ==============================Date=========================================
export const InputDate = (props) => {
    let value = null;
    if (moment(props?.value, "yyyy-MM-DD", true).isValid()) {
      value = new Date(Date.parse(props?.value));
    }
    const handleChange = (newVal) => {
      if (moment(newVal).isValid()) {
        props?.handleChange(props?.name, moment(newVal).format("yyyy-MM-DD"));
      } else {
        props?.handleChange(props?.name, null);
      }
    };
    return (
      <div className="dateinput-div">
        {props?.label && <label className="input-label">{props?.label}</label>}
        <div className="date-input-div">
          <DatePicker
            showIcon
            isClearable
            dateFormat="dd-MMM-YYYY"
            selected={value}
            onChange={handleChange}
          />
          
        </div>
      {props?.error && <p className="input-error-text">{props.error}</p>}
      </div>
    );
  };
  // ==============================Date=========================================
  